import React from "react";
import styled from "@emotion/styled";
import UndoneIcon from "../../assets/icons/QuizIcon.svg";
import DoneIcon from "../../assets/icons/QuizIconDone.svg";
import DoneAllIcon from "../../assets/icons/QuizIconDoneAll.svg";
import { useNavigate } from "react-router-dom";
import { toPercent } from "../../utils/toPercent";

export const QuizCard = ({
  group,
  topic,
  score,
  totalFinish = 0,
  canDo = true,
  clickableCard,
}) => {
  const navigate = useNavigate();
  const isDone = totalFinish === 2;

  const getDoneStateIconImage = (didQuiz, isDone) => {
    if (isDone) return DoneAllIcon;

    return didQuiz ? DoneIcon : UndoneIcon;
  };

  const getDoneIcons = () => {
    let finishStates = [false, false];
    finishStates = finishStates.map((_, i) => i + 1 <= totalFinish);

    return finishStates.map((d) => (
      <DoneStateIcon src={getDoneStateIconImage(d, isDone)} />
    ));
  };

  return (
    <Container
      isDone={isDone}
      clickable={clickableCard}
      onClick={(e) => {
        if (clickableCard) navigate(`/quiz/do/${group}`);
      }}
    >
      <ContentContainer>
        <QuizNoText isDone={isDone}>แบบทดสอบชุดความรู้ที่ {group}</QuizNoText>
        <ActionContainer>
          <div>
            <QuizNameText isDone={isDone}>{topic}</QuizNameText>
            {canDo && !isDone && (
              <ActionButton onClick={(e) => navigate(`/quiz/do/${group}`)}>
                ทำแบบทดสอบ {totalFinish === 1 && "ครั้งที่ 2"}
              </ActionButton>
            )}
          </div>
          {canDo && (
            <DoneStateIconContainer>{getDoneIcons()}</DoneStateIconContainer>
          )}
        </ActionContainer>
        {canDo && !isNaN(score) && totalFinish > 0 && (
          <ScoreContainer isDone={isDone}>
            <ScoreText>{score} คะแนน</ScoreText>
            <ScoreText>
              {score * 10} % {score >= 8 && <strong>ดีมาก</strong>}
            </ScoreText>
          </ScoreContainer>
        )}
      </ContentContainer>
    </Container>
  );
};

const DoneStateIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const DoneStateIconContainer = styled.div`
  margin-bottom: 8px;
`;

const ScoreContainer = styled.div`
  border-top: 2px solid ${(props) => (props.isDone ? "#058459" : "#16af7b")};
  width: 100%;
  height: 100%;
  margin-top: ${(props) => (props.isDone ? "8px" : "16px")};
  display: flex;
  justify-content: space-between;
  color: ${(props) => (props.isDone ? "white" : "#16af7b")};
  font-size: 18px;
`;

const ScoreText = styled.span`
  margin-top: 16px;
`;

const ActionButton = styled.button`
  padding: 8px 24px 8px 24px;
  background: #16af7b;
  color: white;
  border: 0px;
  border-radius: 100px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
`;

const Container = styled.div`
  display: inline-grid;
  border-radius: 8px;
  border: 2px solid ${(props) => (props.isDone ? "#16AF7B" : "#e7eaee")};
  background-color: ${(props) => (props.isDone ? "#16AF7B" : "white")};
  cursor: ${(props) => (props.clickable ? "pointer" : "auto")};
`;

const ContentContainer = styled.div`
  padding: 24px;
  width: 100%;
  height: 100%;
  display: flex column;
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`;

const QuizNameText = styled.p`
  font-family: "Noto Sans Thai";
  font-weight: 600;
  font-size: 24px;
  color: ${(props) => (props.isDone ? "white" : "#058459")};
  margin-bottom: ${(props) => (props.isDone ? "0px" : "24px")};
`;

const QuizNoText = styled.p`
  font-family: "Noto Sans Thai";
  color: ${(props) => (props.isDone ? "white" : "#ff6a40")};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
`;
